function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 304.49,
  y1: 336.97,
  x2: 211.57,
  y2: 201.82,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#754c24"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "141-150");

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 196.5,
  cy: 225.11,
  rx: 140.11,
  ry: 54.12,
  fill: "#8cc63f"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M188.73,224.4c16.33-1.78,33.26-8.35,41.39-21.48-6.63-13.93-20.14-26-46.93-26-32.7,0-46.07,21.08-51.46,36.3a11.12,11.12,0,0,0-.41,1.52C147.89,224.58,170.56,226.38,188.73,224.4Z",
  fill: "#eff0eb"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M184.77,143.11c-1.41,1.64-11.78,68.36-11.78,68.36s13.47,17.59,47,0l-11.8-68.36",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 238.95,
  cy: 199.41,
  rx: 18.95,
  ry: 15.19,
  fill: "#d4d3cf"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 133.28,
  cy: 214.6,
  rx: 22.88,
  ry: 19.33,
  fill: "#e1e3de"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 145.12,
  cy: 229.06,
  rx: 14.8,
  ry: 11.06,
  fill: "#d4d3cf"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 168.24,
  cy: 218,
  rx: 19.5,
  ry: 17.24,
  fill: "#e1e3de"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M232.73,232.78c12.46-1.36,25.37-6.37,31.57-16.39-5.05-10.62-15.36-19.87-35.8-19.87-24.94,0-35.14,16.08-39.25,27.69a8.48,8.48,0,0,0-.31,1.16C201.57,232.92,218.87,234.29,232.73,232.78Z",
  fill: "#e1e3de"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M204.82,246.13c11.91-1.3,24.25-6.09,30.19-15.66-4.83-10.16-14.69-19-34.22-19-23.85,0-33.59,15.37-37.52,26.47A8.11,8.11,0,0,0,163,239C175,246.26,191.57,247.57,204.82,246.13Z",
  fill: "#eff0eb"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 264.3,
  cy: 184.02,
  r: 4.58,
  fill: "#eff0eb"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 241.61,
  cy: 170,
  r: 6.6,
  fill: "#eff0eb"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 148.74,
  cy: 162.9,
  r: 4.37,
  fill: "#eff0eb"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 131.33,
  cy: 181.2,
  r: 7.92,
  fill: "#eff0eb"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M248.76,240.64c5-1.22,9.22-3.59,11.91-8.06a62.11,62.11,0,0,0,3.47-7.34c-2.93-6.24-9.89-10.64-18-10.64-10.77,0-19.5,7.72-19.5,17.24a15.43,15.43,0,0,0,1.32,6.19C233.94,241.88,241.8,242.34,248.76,240.64Z",
  fill: "#d4d3cf"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M186.33,143.25l-7.08,19a6.2,6.2,0,0,0,8.22,0c4.31-3.58.31,7.28,3.87,6.3s3.68-8.54,5.84-5,.78,10.69,3.25,6.24.47-12.33,4-9.17,3.13,7.36,5.34,4.49.6-6.42.6-6.42l4.09,6.91-6.6-27",
  fill: "#f4ac4d"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M210.64,122.39s10.74,11.09,10.72,17.39,0,26.8,0,26.8h-4.49s-9.2-21.1-15.06-28S210.64,122.39,210.64,122.39Z",
  fill: "#e1a621"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M210.64,122.39s10.74,11.09,10.72,17.39,0,26.8,0,26.8h-4.49s-9.2-21.1-15.06-28S210.64,122.39,210.64,122.39Z",
  fill: "#363636",
  opacity: 0.61
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M183.72,122.39S173,133.48,173,139.78s0,26.8,0,26.8h4.49s9.2-21.1,15.06-28S183.72,122.39,183.72,122.39Z",
  fill: "#e1a621"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M183.72,122.39S173,133.48,173,139.78s0,26.8,0,26.8h4.49s9.2-21.1,15.06-28S183.72,122.39,183.72,122.39Z",
  fill: "#363636",
  opacity: 0.61
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M207.71,48.3a93.23,93.23,0,0,0-10.25-20s-5.29,7.15-10.17,20.15C193.35,51.72,200.94,50.67,207.71,48.3Z",
  fill: "#e1a621"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 197.18,
  cy: 93.35,
  rx: 10.91,
  ry: 9.6,
  fill: "#e1a621"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M197.47,28.31S165.11,72,186.64,139.68c0,0,2.44,14.45,10.11,14.15s13.6-16,13.6-16S228,73,197.47,28.31Z",
  fill: "#e1a621"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M207.71,48.3a93.23,93.23,0,0,0-10.25-20s-5.29,7.15-10.17,20.15C193.35,51.72,200.94,50.67,207.71,48.3Z",
  fill: "#363636",
  opacity: 0.61
});

var _ref27 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 197.18,
  cy: 93.35,
  rx: 10.91,
  ry: 9.6,
  fill: "#363636",
  opacity: 0.61
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M186.64,139.68s-7.4,7.64-7.39,12,0,18.46,0,18.46h3.1s6.34-14.54,10.38-19.32S186.64,139.68,186.64,139.68Z",
  fill: "#e1a621"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M207.72,139.68s7.4,7.64,7.39,12,0,18.46,0,18.46H212s-6.34-14.54-10.38-19.32S207.72,139.68,207.72,139.68Z",
  fill: "#e1a621"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M186.64,139.68s-7.4,7.64-7.39,12,0,18.46,0,18.46h3.1s6.34-14.54,10.38-19.32S186.64,139.68,186.64,139.68Z",
  fill: "#363636",
  opacity: 0.29
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M207.72,139.68s7.4,7.64,7.39,12,0,18.46,0,18.46H212s-6.34-14.54-10.38-19.32S207.72,139.68,207.72,139.68Z",
  fill: "#363636",
  opacity: 0.29
});

var SvgRocketLaunch = function SvgRocketLaunch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _ref4, /*#__PURE__*/React.createElement("path", {
    d: "M284.14,268c17.55-6.26,36.85-13.49,47-27.87-27.53-15.83-75.79-39.11-98.51-53.32l-88.95,51.95L211.09,278C235.68,277.82,260.85,276.29,284.14,268Z",
    opacity: 0.63,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocketLaunch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocket_launch.75e10c18.svg";
export { ForwardRef as ReactComponent };